import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { SchirmerTearTestLeftEyeActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-schirmer-tear-test-left-eye-slot-v2',
    templateUrl: './schirmer-tear-test-left-eye-slot-v2.component.html',
    styleUrl: './schirmer-tear-test-left-eye-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchirmerTearTestLeftEyeSlotComponentV2 implements SheetSlotComponentBase {

	action!: SchirmerTearTestLeftEyeActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: SchirmerTearTestLeftEyeActionV2 | null) {
		this.action = action as SchirmerTearTestLeftEyeActionV2;
		this.value = this.action.result?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}